import api from "config/axios";

export const getBillingDetails = async (id) => await api.get(`/billing?workspace_id=${id}`);

export const storeBillingDetails = async (data) => await api.post("/billing", data);

export const updateBillingDetails = async (data) => await api.put("/billing", data);

export const getPaymentMethods = async (data) => await api.get(`/get-card?payment_method=${data}`);